import MetaDataTemplateModel from '../models/MetaDataTemplateModel';
import BaseStore from './BaseStore';
import { action } from 'mobx';

class MetaDataTemplateStore extends BaseStore {
  metaDataStore;

  constructor(transportLayer, metaDataStore) {
    super(MetaDataTemplateModel, transportLayer);
    this.metaDataStore = metaDataStore;
  }

  updateItem(json) {
    const item = this.findById(json.id);
    const _json = {
      ...json,
      meta_data: json.meta_data && json.meta_data.map(metaDataItem => {
        if (metaDataItem.asJson) {
          return metaDataItem.asJson;
        }
        return metaDataItem;
      }),
    };
    return this
      ._update(json.id, _json)
      .then(action(() => {
        item.updateFromJson(json);
      }));
  }
}

export default MetaDataTemplateStore;



// WEBPACK FOOTER //
// ./src/stores/MetaDataTemplateStore.js